@if (jackpot.cmsJackpot$ | async; as cmsJackpot) {
  @if (jackpot.ssJackpot$ | async; as ssJackpot) {
    @if (place === levelsPlace.GAME && (breakpoint.isTablet || breakpoint.isMobile)) {
      <div class="jackpot__levels"
           [ngClass]="{'jackpot': place === levelsPlace.JACKPOT, 'open': isOpened, 'game': place === levelsPlace.GAME, 'game-list': place === levelsPlace.GAME_LIST}"
           (click)="toggle()"
      >
        <div class="jackpot__levels_list js-levels">
          @for (level of cmsJackpot?.Levels; track level; let i = $index) {
            <div class="jackpot__levels_level">
              <img [src]="'/assets/img/jackpot/levels/' + i + '.png'" [alt]="level?.name">
              <div class="jackpot__levels_level--info">
                <div class="jackpot__levels_level--name">{{ level?.name }}</div>
                <div class="jackpot__levels_level--value">
                  <span class="text-gradient">{{ ssJackpot?.currencySymbol }}</span>
                  <app-odometer *appShellNoSSR [number]="ssJackpot?.levels[i]['total']"
                                [config]="{ auto: true, format: '(,ddd).dd' }" [theme]="'gradient'"></app-odometer>
                </div>
                <div class="jackpot__levels_level--min">{{ level?.min }}</div>
                <div class="jackpot__levels_level--range">{{ level?.range }}</div>
              </div>
            </div>
          }
          @if (place === levelsPlace.GAME || place === levelsPlace.GAME_LIST) {
            <div
              class="jackpot__levels_rules"
              (click)="openRulesModal(); $event.stopPropagation()">
              <i class="icon-info"></i>
            </div>
          }
          <div class="jackpot__levels_logo" [ngClass]="{top: !hideJackpotValue}">
            @if (!hideJackpotValue) {
              <div class="jackpot__levels_logo--value">
                <span class="text-gradient">{{ ssJackpot?.currencySymbol }}</span>
                <app-odometer *appShellNoSSR [number]="ssJackpot?.total" [config]="{ auto: true, format: '(,ddd).dd' }"
                              [theme]="'gradient'"></app-odometer>
              </div>
            }
          </div>
        </div>
        <button class="btn"
                [routerLink]="['/', lang.current, 'games', 'bonanza-jackpot']">{{ 'btn.play-n' | translate }}
        </button>
      </div>
    } @else {
      <div class="jackpot__levels" [ngClass]="{
        'jackpot': place === levelsPlace.JACKPOT,
        'game': place === levelsPlace.GAME,
        'game-list': place === levelsPlace.GAME_LIST
       }"
      >
        @if (!isGame() && !breakpoint.belowTablet) {
          <div class="jackpot__levels_list js-levels">
            @for (level of cmsJackpot?.Levels; track level; let i = $index) {
              <div class="jackpot__levels_level">
                <div class="jackpot__levels_level--img">
                  <img ClassLoaded [src]="'/assets/img/jackpot/levels/' + i + '.png'" [alt]="level?.name">
                </div>
                <div class="jackpot__levels_level--info">
                  <div class="jackpot__levels_level--name">{{ level?.name }}</div>
                  <div class="jackpot__levels_level--value">
                    <span class="text-gradient">{{ ssJackpot?.currencySymbol }}</span>
                    <app-odometer *appShellNoSSR [number]="ssJackpot?.levels[i]['total']"
                                  [config]="{ auto: true, format: '(,ddd).dd' }" [theme]="'gradient'"></app-odometer>
                  </div>
                  <div class="jackpot__levels_level--min">{{ level?.min }}</div>
                  <div class="jackpot__levels_level--range">{{ level?.range }}</div>
                </div>
              </div>
            }
            @if (place === levelsPlace.GAME) {
              <div
                class="jackpot__levels_rules"
                (click)="openRulesModal(); $event.stopPropagation()">
                <i class="icon-info"></i>
              </div>
            }
          </div>
        } @else {
          @if (!isGame()) {
            <ng-container *ngTemplateOutlet="mobileSlider"></ng-container>
          }
          @if (isGame() && !breakpoint.belowTablet) {
            <ng-container *ngTemplateOutlet="specialDesktopGameView"></ng-container>
          }
        }
        <ng-template #mobileSlider>
          <div class="jackpot__levels_slider--wrapper">
            <div class="jackpot__levels_slider">
              <app-slider
                #levelsSlider
                class="slider"
                [slideList]="cmsJackpot?.Levels"
                [config]="sliderLevelsConfig">
                @for (item of levelsSlider?.slideList(); track item; let i = $index) {
                  <div class="slider__slide keen-slider__slide">
                    <div class="slide-container">
                      <div class="img">
                        <img [src]="'/assets/img/jackpot/levels/' + i + '.png'" alt="">
                      </div>
                      <div class="jackpot__levels_level--info">
                        <div class="jackpot__levels_level--name">{{ item?.name }}</div>
                        <div class="jackpot__levels_level--value">
                          <span class="text-gradient">
                            {{ ssJackpot?.currencySymbol }}
                          </span>
                          <app-odometer
                            *appShellNoSSR
                            [number]="ssJackpot?.levels[i]['total']"
                            [config]="{ auto: true, format: '(,ddd).dd' }"
                            [theme]="'gradient'"></app-odometer>
                        </div>
                        <div class="jackpot__levels_level--min">{{ item?.min }}</div>
                        <div class="jackpot__levels_level--range">{{ item?.range }}</div>
                      </div>
                      @if (place === levelsPlace.GAME) {
                        <div
                          class="jackpot__levels_rules"
                          (click)="openRulesModal(); $event.stopPropagation()">
                          <i class="icon-info"></i>
                        </div>
                      }
                    </div>
                  </div>
                }
              </app-slider>
            </div>
            @if (cmsJackpot?.Levels?.length > 1) {
              <div class="pagination-container">
                <app-radial-progress
                  (click)="levelsSlider?.slider?.prev()"
                  [strokeWidth]="0"
                  [autoplay]="false"
                  [arrow]="'up'">
                </app-radial-progress>
                <ng-container *ngTemplateOutlet="levelsSlider?.paginationElement()"></ng-container>
                <app-radial-progress
                  (click)="levelsSlider?.slider?.next()"
                  [autoplay]="false"
                  [strokeWidth]="0"
                  [arrow]="'down'">
                </app-radial-progress>
              </div>
            }
          </div>
        </ng-template>
        <ng-template #specialDesktopGameView>
          <div class="in-game">
            <div class="in-game__title">
              {{ 't.bonanza-jackpot' | translate }}
            </div>
            <div class="in-game__prize-label">
              {{ 't.prize-pool' | translate }}
            </div>
            <img src="/assets/img/jackpot/game-box.png" alt="jackpot" class="in-game__img">
            @if (place === levelsPlace.GAME) {
              <div class="in-game__info" (click)="openRulesModal(); $event.stopPropagation()">
                <img src="/assets/img/jackpot/info.png" alt="info">
              </div>
            }
            <div class="in-game__pool">
              <app-odometer *appShellNoSSR [number]="ssJackpot?.total"
                            [config]="{ auto: true, format: '(,ddd).dd' }"
                            [theme]="'gradient'">
              </app-odometer>
              <span class="text-gradient">{{ ssJackpot?.currency }}</span>
            </div>
            <hr />
            <div class="accordion">
              <div class="accordion__header"
                   Accordion
                   #accordionHeader=accordionDirective>
                <div class="accordion__header-icon-cont" (click)="openAccordion()">
                  <i class="accordion__header-icon icon-arrow"></i>
                </div>
              </div>
              <div class="accordion__content">
                <div class="accordion__content-container">
                  <div class="in-game__levels">
                    @for (level of cmsJackpot?.Levels; track level; let i = $index) {
                      <div class="in-game__levels-item">
                        <div>
                          <div class="in-game__levels-image">
                            <img ClassLoaded [src]="'/assets/img/jackpot/levels/' + i + '.png'" [alt]="level?.name">
                          </div>
                        </div>
                        <div class="in-game__levels-section">
                          <div>
                            <div class="in-game__levels-name">{{ level?.name }}</div>
                          </div>
                          <div class="in-game__levels-info">
                            <span class="text-gradient">{{ ssJackpot?.currencySymbol }}</span>
                            <app-odometer *appShellNoSSR [number]="ssJackpot?.levels[i]['total']"
                                          [config]="{ auto: true, format: '(,ddd).dd' }"
                                          [theme]="'gradient'">
                            </app-odometer>
                          </div>
                          <div class="in-game__levels-min">{{ level?.min }}</div>
                          <div class="in-game__levels-range">{{ level?.range }}</div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <div class="levels__action">
          <button class="btn"
                  [routerLink]="['/', lang.current, 'games', 'bonanza-jackpot']">{{ 'btn.play-n' | translate }}
          </button>
        </div>
      </div>
    }
  }
}

